import React from "react";
import { Typography } from "@material-ui/core";
import { CustomBox } from "components/Box/CustomBox";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import { iconStyle } from "./CustomerView";
import { useSelector } from "react-redux";
import { useScrollTop } from "hooks/useScrollTop";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { blue } from "@material-ui/core/colors";
import RegularButton from "components/CustomButtons/Button";
import { useCopyText } from "hooks/useCopyText";
import { DisplayAccountCredit } from "./accounts/DisplayAccountCredit";

export const InfoChildren = ({ label, height, border, component, count }) => {
  const { account, editCustomer, customer } = useSelector(
    ({ customersReducer }) => customersReducer
  );
  useScrollTop(account);
  const copy = useCopyText(account?.code, `${account?.code} copiado con éxito`);
  const copy2 = useCopyText(customer?.code, `${customer?.code} copiado con éxito`);
  const creditAccount = account?.creditAccounts

  return (
    <CustomBox
      title={label}
      count={count}
      icon={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          {creditAccount && (
            <DisplayAccountCredit creditAccount={creditAccount}/>
          )}
          <Typography variant="body1">
            Codigo: {editCustomer ? customer?.code : account?.code}
            <RegularButton
              color="transparent"
              justIcon
              round
              tooltip={`Copiar código de ${editCustomer ? "cliente": "cuenta"}`}
              onClick={editCustomer ? copy2 : copy}
              style={{ margin: 0 }}
            >
              <FileCopyIcon style={{ color: blue[500] }} />
            </RegularButton>
          </Typography>
          <AccountBoxIcon style={iconStyle} />
        </div>
      }
      style={{ height, boxShadow: border, overflowY: "scroll" }}
    >
      {component}
    </CustomBox>
  );
};
